import { render, staticRenderFns } from "./DetailRoles.vue?vue&type=template&id=3a8ff970&"
import script from "./DetailRoles.vue?vue&type=script&lang=js&"
export * from "./DetailRoles.vue?vue&type=script&lang=js&"
import style0 from "./DetailRoles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports